"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileUserFeedback = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_buoy_button_1 = require("@buoyhealth/common.buoy-button");
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const Drawer_1 = __importDefault(require("@mui/material/Drawer"));
const styles_1 = require("@mui/material/styles");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ImageHeader_1 = __importDefault(require("../ImageHeader"));
const SurveyThankYou_1 = __importDefault(require("../SurveyThankYou"));
const SurveyQuestion_1 = __importDefault(require("../SurveyQuestion"));
const withSnowplowTracking_1 = __importDefault(require("../withSnowplowTracking"));
const FeedbackCopy_1 = __importDefault(require("../../common/FeedbackCopy"));
const PromptParagraph = styled_components_1.default.p `
  ${({ theme }) => theme.typography.variants.primary.large};
  margin: 32px 0 24px;
`;
const PromptDrawer = (0, styled_components_1.default)(Drawer_1.default) `
  .MuiDrawer-paper {
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
  }
`;
const PromptDrawerContainer = styled_components_1.default.div `
  padding: 0 0 32px 24px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;
const DrawerContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}px) {
    padding: 32px;
  }
`;
const ThankYouContainer = styled_components_1.default.div `
  overflow: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    padding: 24px 15px;
  }
`;
const QuestionnaireDrawer = (0, styled_components_1.default)(Drawer_1.default) `
  .MuiDrawer-paper {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    height: 90%;
  }
`;
const CloseButtonContainer = styled_components_1.default.div `
  margin: 3px;
`;
const QuestionnaireCloseButtonContainer = styled_components_1.default.div `
  position: absolute;
  top: 8px;
  right: 8px;
`;
const MobileUserFeedback = ({ isQuestionnaireComplete, isVisible, lastSubmittedQuestionIndex, onAnswerSubmit, onClose, onGiveFeedbackClick, onSurveyClick, surveyLink, }) => {
    const r = (0, common_buoy_theme_1.useResponsive)();
    const theme = (0, styles_1.useTheme)();
    const [isQuestionnaireOpen, setIsQuestionnaireOpen] = (0, react_1.useState)(false);
    const [isPromptOpen, setIsPromptOpen] = (0, react_1.useState)(false);
    const showImageHeader = r({ xs: false, md: true }) || isQuestionnaireComplete;
    (0, react_1.useEffect)(() => {
        setIsPromptOpen(!!isVisible);
    }, [isVisible]);
    const closeAllDrawers = () => {
        setIsPromptOpen(false);
        setIsQuestionnaireOpen(false);
    };
    /** User has dismissed the feedback modal */
    const handleClose = () => {
        closeAllDrawers();
        onClose();
    };
    const openQuestionnaire = () => {
        onGiveFeedbackClick();
        setIsPromptOpen(false);
        setIsQuestionnaireOpen(true);
    };
    const handleSurveyClick = () => {
        onSurveyClick();
        closeAllDrawers();
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!isQuestionnaireOpen && ((0, jsx_runtime_1.jsx)(PromptDrawer, { anchor: "bottom", open: isPromptOpen, variant: "persistent", children: (0, jsx_runtime_1.jsxs)(PromptDrawerContainer, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(PromptParagraph, { "data-testid": "mobile-feedback-prompt", children: [FeedbackCopy_1.default.InitialPrompt1, " ", FeedbackCopy_1.default.InitialPrompt2] }), (0, jsx_runtime_1.jsx)(common_buoy_button_1.TextButton, { "data-testid": "give-feedback-button", onClick: openQuestionnaire, children: FeedbackCopy_1.default.GiveFeedback })] }), (0, jsx_runtime_1.jsx)(CloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "close-button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.text.primary, size: 24 }) }) })] }) })), (0, jsx_runtime_1.jsxs)(QuestionnaireDrawer, { anchor: "bottom", open: isQuestionnaireOpen, children: [showImageHeader ? ((0, jsx_runtime_1.jsx)(ImageHeader_1.default, { backgroundColor: r({ md: theme.palette.teal[0] }), closeIconColor: theme.palette.primary.main, onClose: handleClose })) : ((0, jsx_runtime_1.jsx)(QuestionnaireCloseButtonContainer, { children: (0, jsx_runtime_1.jsx)(IconButton_1.default, { "data-testid": "close-button", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.CloseIconThin, { color: theme.palette.primary.main, size: 32 }) }) })), (0, jsx_runtime_1.jsx)(DrawerContainer, { children: isQuestionnaireComplete ? ((0, jsx_runtime_1.jsx)(ThankYouContainer, { children: (0, jsx_runtime_1.jsx)(SurveyThankYou_1.default, { handleClose: handleClose, handleSurveyClick: handleSurveyClick, surveyLink: surveyLink }) })) : ((0, jsx_runtime_1.jsx)(SurveyQuestion_1.default, { isMobile: true, lastSubmittedQuestionIndex: lastSubmittedQuestionIndex, onAnswerSubmit: onAnswerSubmit })) })] })] }));
};
exports.MobileUserFeedback = MobileUserFeedback;
exports.default = (0, withSnowplowTracking_1.default)(exports.MobileUserFeedback);
//# sourceMappingURL=index.js.map